module.exports = __webpack_public_path__ + "static/media/banner.acffe7ec.png";